export default "__VITE_ASSET__f5cb2f26__"